/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Form } from '@organisms';

import ArticleTagSelect from '../ArticleTagSelect';

const ArticleTagField = ({ onChange, disabled, ...props }) => (
  <Form.Item {...props}>
    <ArticleTagSelect onChange={onChange} disabled={disabled} />
  </Form.Item>
);

export default ArticleTagField;
